export interface MemberResource {
  type: 'Member'
  id: number
  name: string
  avatar: string
  badges: MemberBadge[]
  child: boolean
  directMessagesDisabled?: boolean
  canDirectMessage?: boolean
  gender: string | null
  role?: string
}

export interface MemberBadge {
  title: string
}
